import styled from "styled-components";

interface Props {
  width?: number;
  active?: boolean | "hover";
}

export const ReviewBriefIconSvg = (props: Props) => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_10521_11380)">
        <path
          d="M44.0625 22.5C44.0625 10.5914 34.4086 0.9375 22.5 0.9375C10.5914 0.9375 0.9375 10.5914 0.9375 22.5C0.9375 34.4086 10.5914 44.0625 22.5 44.0625C34.4086 44.0625 44.0625 34.4086 44.0625 22.5Z"
          stroke="url(#paint0_linear_10521_11380)"
          stroke-width="2"
        />
        <path
          d="M22.5088 32.9102C21.1351 32.9102 19.846 32.6497 18.6416 32.1289C17.4372 31.6146 16.3792 30.9017 15.4678 29.9902C14.5563 29.0788 13.8402 28.0208 13.3193 26.8164C12.805 25.612 12.5479 24.3229 12.5479 22.9492C12.5479 21.8359 12.7171 20.7812 13.0557 19.7852C13.4007 18.7826 13.8825 17.8678 14.501 17.041C15.126 16.2077 15.8584 15.4883 16.6982 14.8828C16.9131 14.7135 17.141 14.6517 17.3818 14.6973C17.6227 14.7428 17.805 14.8633 17.9287 15.0586C18.0524 15.2669 18.085 15.4785 18.0264 15.6934C17.9743 15.9017 17.8473 16.0807 17.6455 16.2305C16.9554 16.7253 16.3532 17.321 15.8389 18.0176C15.3245 18.7077 14.9242 19.4694 14.6377 20.3027C14.3512 21.1361 14.208 22.0182 14.208 22.9492C14.208 24.0951 14.4229 25.1693 14.8525 26.1719C15.2822 27.1745 15.8779 28.0566 16.6396 28.8184C17.4014 29.5801 18.2835 30.1758 19.2861 30.6055C20.2887 31.0352 21.363 31.25 22.5088 31.25C23.6546 31.25 24.7288 31.0352 25.7314 30.6055C26.734 30.1758 27.6162 29.5801 28.3779 28.8184C29.1396 28.0566 29.7354 27.1745 30.165 26.1719C30.5947 25.1693 30.8096 24.0951 30.8096 22.9492C30.8096 21.9596 30.6468 21.0221 30.3213 20.1367C30.0023 19.2513 29.5531 18.4538 28.9736 17.7441C28.3942 17.028 27.7139 16.4225 26.9326 15.9277C26.1579 15.4329 25.3115 15.0781 24.3936 14.8633V16.2695C24.3936 16.4974 24.3447 16.6699 24.2471 16.7871C24.1559 16.9043 24.0322 16.9629 23.876 16.9629C23.7262 16.9564 23.5602 16.8913 23.3779 16.7676L20.2627 14.5801C20.0413 14.4238 19.9274 14.2415 19.9209 14.0332C19.9209 13.8249 20.0348 13.6393 20.2627 13.4766L23.3682 11.2891C23.5505 11.1654 23.7197 11.1003 23.876 11.0938C24.0322 11.0872 24.1559 11.1426 24.2471 11.2598C24.3447 11.377 24.3936 11.5527 24.3936 11.7871V13.1738C25.5329 13.3887 26.5908 13.7891 27.5674 14.375C28.5505 14.9544 29.4098 15.6803 30.1455 16.5527C30.8812 17.4251 31.4508 18.4049 31.8545 19.4922C32.2646 20.5794 32.4697 21.7318 32.4697 22.9492C32.4697 24.3229 32.2093 25.612 31.6885 26.8164C31.1742 28.0208 30.4613 29.0788 29.5498 29.9902C28.6383 30.9017 27.5804 31.6146 26.376 32.1289C25.1715 32.6497 23.8825 32.9102 22.5088 32.9102ZM21.4443 27.5781C21.2816 27.5781 21.1318 27.5423 20.9951 27.4707C20.8649 27.3991 20.738 27.2852 20.6143 27.1289L18.2314 24.1992C18.0817 23.9974 18.0068 23.7956 18.0068 23.5938C18.0068 23.3789 18.0785 23.1966 18.2217 23.0469C18.3714 22.8906 18.5505 22.8125 18.7588 22.8125C18.8955 22.8125 19.0192 22.8418 19.1299 22.9004C19.2471 22.9525 19.3643 23.0566 19.4814 23.2129L21.4053 25.7031L25.458 19.1992C25.6403 18.9062 25.8682 18.7598 26.1416 18.7598C26.3434 18.7598 26.5257 18.8249 26.6885 18.9551C26.8512 19.0853 26.9326 19.2578 26.9326 19.4727C26.9326 19.5833 26.9066 19.694 26.8545 19.8047C26.8089 19.9089 26.7568 20.0065 26.6982 20.0977L22.2354 27.1289C22.04 27.4284 21.7764 27.5781 21.4443 27.5781Z"
          fill="#3D3C5A"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10521_11380"
          x1="4.37308e-08"
          y1="22.5005"
          x2="44.9992"
          y2="22.5005"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.13" stop-color="#FA3CAB" />
          <stop offset="0.24" stop-color="#F94C94" />
          <stop offset="0.57" stop-color="#F87C54" />
          <stop offset="0.81" stop-color="#F79A2C" />
          <stop offset="0.94" stop-color="#F7A61D" />
        </linearGradient>
        <clipPath id="clip0_10521_11380">
          <rect width="45" height="45" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ReviewBriefIcon = styled(ReviewBriefIconSvg)<{
  active?: boolean;
}>`
  & path:first-of-type {
    stroke: ${(p) => p.theme.color.typography.secondary}80;
  }

  & path:nth-of-type(2) {
    fill: ${(p) => p.theme.color.typography.secondary};
  }

  ${(p) =>
    p.active &&
    `
    path:first-of-type {
      stroke: url(#paint0_linear_10521_11380);
    }

    path:nth-of-type(2) {
      fill: ${p.theme.color.typography.text};
    }
  `}

  .active & path:first-of-type {
    stroke: url(#paint0_linear_10521_11380);
  }

  .active & path:nth-of-type(2) {
    fill: ${(p) => p.theme.color.typography.text};
  }
`;
